import { useState } from "react";
import { MessageSquarePlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FeedbackDialog } from "./FeedbackDialog";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function FeedbackButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            className="fixed bottom-5 right-5 z-40 h-10 w-10 rounded-full shadow-md border-muted-foreground/20 bg-background/90 backdrop-blur-sm hover:bg-accent"
            onClick={() => setOpen(true)}
          >
            <MessageSquarePlus className="h-5 w-5 text-muted-foreground" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left">Send Feedback</TooltipContent>
      </Tooltip>
      <FeedbackDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
